import React from "react";

import { TabType } from "@constants";
import { ResultsListItemType, LocalizationTexts } from "../types";

import { ResultsListItem } from ".";

interface Props {
  items: ResultsListItemType[];
  type: TabType;
  localization: LocalizationTexts;
  iconsList: any;
}

const ResultsList: React.FC<Props> = ({ items, type, localization, iconsList }) => {
  if (!items?.length) return null;

  return (
    <ul data-testid={`branches-atms-${type}`}>
      {items.map((item) => (
        <ResultsListItem
          key={item.id}
          sourceItemId={item.sourceItemId}
          type={type}
          localization={localization}
          iconsList={iconsList}
          {...item}
        />
      ))}
    </ul>
  );
};

export default ResultsList;
